import { compose, grid as muiGrid, style } from "@material-ui/system";
export var gridGap = style({
    prop: "gridGap",
    themeKey: "spacing",
});
export var gridColumnGap = style({
    prop: "gridColumnGap",
    themeKey: "spacing",
});
export var gridRowGap = style({
    prop: "gridRowGap",
    themeKey: "spacing",
});
export var grid = compose(muiGrid, 
// MUI's default system does not use the theme for spacing. Overriding these here.
gridGap, gridColumnGap, gridRowGap);
